import { Container }  from "../components/Container";

import {Quality} from "../components/Quality";

export default function Page() {
  return (
    <Container>
      <Quality />
    </Container>
  );
}
